import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components";

import { TestAppState } from "../../app";
import { addAuditCard } from "./cards/audit";
import { addPercentageOfBudgetSpentCard } from "./cards/budget";
import { addCategoryCard } from "./cards/category";
import { addCompletedItemsCards } from "./cards/completed-items";
import { addCompletedItemsOverTimeCards } from "./cards/completed-items-over-time";
import { addCompletedItemsPerCategoryLevelCard } from "./cards/completed-items-per-category-level";
import { addCompletionCard } from "./cards/completion";
import { addCompletionByMaturityCards } from "./cards/completion-by-maturity";
import { addCountCompletionCard } from "./cards/count-completion";
import { addCountStatusCard } from "./cards/count-status";
import { addDescriptionCard } from "./cards/description";
import { addDimensionOverviewCard } from "./cards/dimension-overview";
import { addDonutChartCards } from "./cards/donuts";
import { addManagementSummaryCard } from "./cards/management-summary";
import { addMaturityCards } from "./cards/maturity";
import { addNarrativeDescriptionCards } from "./cards/narrative-descriptions";
import { addNumberOfDueItemsCard } from "./cards/number-of-due-items";
import { addNumberOfItemsCard } from "./cards/number-of-items";
import { addProjectDurationCard } from "./cards/project-duration";
import { addReportingProgressCard } from "./cards/reporting-progress";
import { addStatusCard } from "./cards/status";
import { addProjectTeamCard } from "./cards/team";
import { addTitleCard } from "./cards/title";
import { addTrackingItemsTitleCard } from "./cards/tracking-items-title";

type ReportCard = (
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) => void;

/**
 * Every *static* card the report page is made of, **in the order they are
 * added**, up to (but not including) the tracking items table (#2222).
 *
 * The order is the point of this array: the drag-and-drop layout places
 * cards by the sequence in which they reach the view. Keeping it as data
 * rather than a run of calls inside the plugin is what lets a spec assert it
 * — see `report-plugin.structure.spec.ts`.
 *
 * The tracking items table is not in this list: at roughly 1,100 lines,
 * carrying the table's columns, cell renderers, and sort/filter/column-
 * configuration state, it needs its own focused follow-up rather than being
 * folded into this mechanical split. `ReportPlugin` still builds it directly
 * in `addComponentsToLayout`, right after these cards.
 *
 * Cards that never touch the app declare `(view)` alone; a narrower
 * parameter list is assignable to the wider type, so they need no unused
 * second parameter to sit in this array.
 */
export const REPORT_CARDS: ReportCard[] = [
  addTitleCard,
  addCategoryCard,
  addStatusCard,
  addCompletionCard,
  addDimensionOverviewCard,
  addMaturityCards,
  addNumberOfItemsCard,
  addNarrativeDescriptionCards,
  addCompletedItemsCards,
  addCompletedItemsOverTimeCards,
  addNumberOfDueItemsCard,
  addProjectTeamCard,
  addAuditCard,
  addProjectDurationCard,
  addReportingProgressCard,
  addPercentageOfBudgetSpentCard,
  addDescriptionCard,
  addManagementSummaryCard,
  addDonutChartCards,
  addCompletionByMaturityCards,
  addTrackingItemsTitleCard,
  addCountStatusCard,
  addCompletedItemsPerCategoryLevelCard,
  addCountCompletionCard,
];
